'use client';

import { Grid, MenuItem, Select } from '@mui/material';
import { ExceedingAmountDecisionEnum } from 'parkchirp-shared/enums';
import React, { useState } from 'react';

import { EditorModal } from '../modals/editorModal';

interface ParkerTerminationErrorModalProps {
	handleClose: () => void;
	handleSave: (useZeroAdjustments: ExceedingAmountDecisionEnum) => void;
	loading: boolean;
	containerClassName?: string;
	theme?: any;
}

// the modal we show to the user when a termination would create
// an adjustment that would exceed the current invoice's balance.
export const ParkerTerminationErrorModal = ({
	handleClose,
	handleSave,
	loading = false,
	containerClassName = '',
	theme,
}: ParkerTerminationErrorModalProps) => {
	const [descision, setDescision] = useState<ExceedingAmountDecisionEnum>(
		ExceedingAmountDecisionEnum.ADJUST_AMOUNTS_TO_ZERO,
	);

	return (
		<EditorModal
			handleClose={handleClose}
			handleSave={() => handleSave(descision)}
			headerText='Termination'
			hasUnsavedChanges={false}
			loading={loading}
			containerClassName={containerClassName}
			theme={theme}
		>
			<Grid container direction='column'>
				<Grid>
					One or more line items cannot be prorated properly due to existing payments/adjustments. What would
					you like to do?
				</Grid>
				<Grid mt='1em' mb='1em'>
					<Select
						value={descision}
						onChange={(e) => setDescision(e.target.value as ExceedingAmountDecisionEnum)}
					>
						<MenuItem value={ExceedingAmountDecisionEnum.ADJUST_AMOUNTS_TO_ZERO}>
							Adjust the line item to $0
						</MenuItem>
						<MenuItem value={ExceedingAmountDecisionEnum.SKIP_PRORATION}>
							Skip proration for the line item
						</MenuItem>
					</Select>
				</Grid>
			</Grid>
		</EditorModal>
	);
};
